import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActionCardComponent } from '@shared/components/action-card/action-card.component';
import { TipoEventoNFeEnum } from '@shared/enums/dfe/tipo-evento-nfe.enum';
import {
  EVENTOS_MANIFESTACAO_CONCLUSIVA_NFE,
  TAMANHO_MINIMO_JUSTIFICATIVA_MANIFESTACAO,
} from '@shared/helpers/manifestacao-nfe.helper';
import { ManifestarNotaFiscalEntradaDialogData } from './manifestar-nota-fiscal-entrada-dialog-data';
import { ManifestarNotaFiscalEntradaDialogResult } from './manifestar-nota-fiscal-entrada-dialog-result';

/** Escolhe o evento conclusivo da manifestação; a chamada à SEFAZ fica com a listagem. */
@Component({
  selector: 'app-manifestar-nota-fiscal-entrada-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatTooltipModule,
    ActionCardComponent,
  ],
  templateUrl: './manifestar-nota-fiscal-entrada-dialog.component.html',
  styleUrl: './manifestar-nota-fiscal-entrada-dialog.component.css',
})
export class ManifestarNotaFiscalEntradaDialogComponent {
  readonly eventos = EVENTOS_MANIFESTACAO_CONCLUSIVA_NFE;
  readonly tamanhoMinimoJustificativa = TAMANHO_MINIMO_JUSTIFICATIVA_MANIFESTACAO;
  readonly justificativa = new FormControl('', {
    nonNullable: true,
    validators: [
      Validators.required,
      Validators.minLength(TAMANHO_MINIMO_JUSTIFICATIVA_MANIFESTACAO),
      Validators.maxLength(255),
    ],
  });
  idTipoEventoSelecionado: TipoEventoNFeEnum | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ManifestarNotaFiscalEntradaDialogData,
    private dialogRef: MatDialogRef<ManifestarNotaFiscalEntradaDialogComponent>
  ) {}

  get isJustificativaObrigatoria(): boolean {
    return this.eventos.some(x => x.idTipoEvento === this.idTipoEventoSelecionado && x.isJustificativaObrigatoria);
  }

  cancelar(): void {
    this.dialogRef.close();
  }

  confirmar(): void {
    if (this.idTipoEventoSelecionado === null) return;
    if (this.isJustificativaObrigatoria) {
      this.justificativa.markAsTouched();
      if (this.justificativa.invalid) return;
    }
    const result = new ManifestarNotaFiscalEntradaDialogResult();
    result.idTipoEvento = this.idTipoEventoSelecionado;
    result.justificativa = this.isJustificativaObrigatoria ? this.justificativa.value.trim() : null;
    this.dialogRef.close(result);
  }
}
